import { Paginator } from "primereact/paginator";
import { useState } from "react";
import PropTypes from 'prop-types';

const CustomTable = ({
  columns,
  data,
  isPagination,
  totalRecords,
  handlePageChange,
  loading,
}) => {
  const [limit, setLimit] = useState(10);
  const [first, setFirst] = useState(0);

  const onPageChange = (event) => {
    const newPage = event ? event?.page + 1 : 1;
    const newLimit = event?.rows || 10;
    const newFirst = event?.first || 1;
    setLimit(newLimit);
    setFirst(newFirst);
    handlePageChange(newPage, newLimit);
  };

  return (
    <>
      <div className="w-full mb-6 xs:mb-12 xl:mb-0 mx-auto mt-3.5 lg:mt-5 2xl:mt-7">
        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded-tl-2xl rounded-tr-2xl overflow-hidden">
          <div className="table_responsive overflow-y-auto">
            <table className="items-center bg-transparent w-full border-collapse">
              <thead className="bg-secondary">
                <tr>
                  {columns.map((column) => (
                    <th
                      className="text-14 xl:text-16 text-primary font-semibold py-2.5 px-2 xl:py-4 xl:px-3 text-center text-nowrap"
                      key={column.key}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.length ? (
                  data?.map((row, rowIndex) => (
                    <tr className="text-center border-b border-l border-r border-b3 hover:shadow-custom_shadow_2" key={rowIndex}>
                      {columns.map((column) => (
                        <td
                          key={column.key}
                          className={`text-[12px] md:text-14 xl:text-16 text-text_1 font-normal py-1.5 px-1.5 lg:py-2.5 lg:px-2 2xl:py-4 2xl:px-3 text-nowrap ${(rowIndex === 0 || rowIndex === data?.length - 1) && "text-nowrap"}`}
                        >
                          {column.renderCell
                            ? column.renderCell(column.key, row, rowIndex)
                            : row[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length}>
                      <div className="w-full bg-white">
                        <div className="w-full flex justify-center p-5 ng-star-inserted">
                          <div className="max-w-8xl w-full rounded-2xl p-10 mx-auto bg-gray_1">
                            <strong className="block text-xl lg:text-2xl 2xl:text-4xl text-center">
                              No data
                            </strong>
                            <span className="block lg:text-18 text-center text-t2">
                              Please add Data
                            </span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {loading === true && (
              <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-slate-300/30 backdrop-blur-sm z-10">
                <div className="flex flex-col items-center justify-center">
                  <div className="w-12 h-12 rounded-full animate-spin border-4 border-solid border-primary border-t-transparent"></div>
                  <p className="block text-base font-medium pt-2">
                    Please wait
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isPagination && data?.length > 0 && (
        <div className="flex border-top border-b3 mt-auto">
          <div className="flex items-center md:justify-end justify-center ml-auto paginator_custom">
            <Paginator
              className="mx-auto xs:mx-0"
              rowsPerPageOptions={[10, 20, 50, 100, 200]}
              first={first}
              rows={limit}
              totalRecords={totalRecords}
              onPageChange={onPageChange}
            />
          </div>
        </div>
      )}
    </>
  );
};
CustomTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      renderCell: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isPagination: PropTypes.bool,
  loading: PropTypes.bool,
  totalRecords: PropTypes.number,
  handlePageChange: PropTypes.func.isRequired,
};

CustomTable.defaultProps = {
  isPagination: true,
  totalRecords: 0,
};

export default CustomTable;
